<template>
  <div class="players">
    <AdminNavBar/>

    <main role="main" class="ml-sm-auto px-4">
      <div v-if="players">
        <b-container fluid>
          <b-row>
            <b-col class="my-1">
              <b-form-group
                label="Filter"
                label-cols-sm="1"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    @input.native="setplayersFilter()"
                    v-model="playersFilter"
                    type="search"
                    id="filterInput"
                    placeholder="Search by Username or Game Name"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!playersFilter"
                      @click="playersFilter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                size="sm"
                class="float-right"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-container>

        <b-link
          @click="load"
          size="sm"
          class="float-left"
          ><small>Refresh</small></b-link
        >
        <div class="ml-2 mb-0 float-right text-muted">
          <small>count {{ totalRows }}</small>
        </div>

        <b-table
          id="my-table"
          :per-page="perPage"
          :current-page="currentPage"
          no-border-collapse
          :items="items"
          :fields="fields"
          :filter="playersFilter"
          :filter-included-fields="['username', 'games_played']"
          @filtered="onFiltered"
          :debounce="3000"
          hover
          responsive="sm"
          small
        >
          <template v-slot:cell(username)="row">
            {{ row.item.username }}
          </template>
          <template v-slot:cell(open)="row">
            <b-btn size="sm" @click="open(row.item)">Open</b-btn>
          </template>
          <template v-slot:cell(remove)="row">
            <b-btn size="sm" variant="danger" @click="remove(row.item)"
              >Delete</b-btn
            >
          </template>
        </b-table>
      </div>
      <div v-else>
        <p>Loading...</p>
        <b-overlay :show="items.length == 0" rounded="sm"> </b-overlay>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import Gravatar from "vue-gravatar";
import axios from "axios";
import dayjs from "dayjs";

const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

Vue.component("v-gravatar", Gravatar);

import AdminNavBar from '../components/AdminNavBar';

import { IconsPlugin } from "bootstrap-vue";
Vue.use(IconsPlugin);

export default {
  name: "players",
  components: {
    AdminNavBar,
  },
  data: function () {
    return {
      perPage: 35,
      currentPage: 1,
      players: null,
      fields: [],
      items: [],
      totalRows: 0,
      playersFilter: "",
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
    },
    setplayersFilter() {
      this.$store.commit("playersFilter", this.playersFilter);
    },
    open(player) {
      this.$router.push({ name: 'player', params: { id: player._id } })
    },
    remove(player) {
      this.$bvModal
        .msgBoxConfirm(
          `Please confirm that you want to delete "${player.username}".`,
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(value => {
          if (value) {
            axios
              .post(
                process.env.VUE_APP_API_URL + '/players/del',
                { _id: player._id },
                {
                  headers: { authorization: localStorage.getItem('vle.user.token') },
                }
              )
              .then(() => {
                this.items = this.items.filter(d => d !== player);
                this.totalRows -= 1;   //XXX: does not seem right!
              });
          }
        });
    },
    load() {
      this.items = [];
      axios
        .post(
          process.env.VUE_APP_API_URL + '/players/list',
          {},
          { headers: { authorization: localStorage.getItem('vle.user.token') } }
        )
        .then(response => {
          this.players = response.data;
          this.players.forEach((d) => {
            d.cases_played = d.logs.length;
            d.last_play = d.logs.length > 0 ? dayjs([...d.logs].pop().start_timestamp).format('MM-DD-YY hh:mm:ss A') : 'NA';

            d.cases_passed = 0;
            d.total_play_time = 0;
            let hasNA = false;
            d.logs.forEach((l) => {

              let time_played;
              if (l.time_played === -1 || l.time_played === undefined || l.time_played === 0) {
                if (l.end_timestamp !== null && l.end_timestamp !== undefined) {
                  time_played = l.end_timestamp - l.start_timestamp;
                } else {
                  time_played = 0;
                  hasNA = true;
                }
              } else {
                time_played = l.time_played * 1000;
              }

              d.total_play_time += time_played;

              if (l.pass) {
                d.cases_passed++;
              }
            });

            d.total_play_time = dayjs.duration(d.total_play_time).format('HH:mm:ss');
            d.total_play_time += hasNA ? ' *' : '';

            let ids = [];
            d.logs.forEach((d) => ids.push(d.game_id));
            ids = [...new Set(ids)];
            d.games_played = ids.length;

            this.items.push(d);
          });
          this.totalRows = this.items.length;
        });
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.playersFilter = this.$store.state.playersFilter;
    this.fields = [
      { key: "username", sortable: true },
      { key: "games_played", sortable: true },
      { key: "cases_played", sortable: true },
      { key: "cases_passed", sortable: true },
      { key: "last_play", sortable: true },
      { key: "total_play_time", sortable: true },
      { key: "open", sortable: false },
    ];
    if (this.$store.state.user.role === "admin") {
      this.fields.push({ key: "remove", sortable: false });
    }
    this.load();
  },
};
</script>
